var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 20,
    viewBox: "0 0 28 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4187 1.40571C25.5661 1.72057 26.4697 2.6483 26.7764 3.82643C27.3337 5.96166 27.3337 10.4168 27.3337 10.4168C27.3337 10.4168 27.3337 14.8718 26.7764 17.0072C26.4697 18.1854 25.5661 19.1131 24.4187 19.4281C22.3393 20.0002 14.0003 20.0002 14.0003 20.0002C14.0003 20.0002 5.66139 20.0002 3.58184 19.4281C2.43442 19.1131 1.53078 18.1854 1.22411 17.0072C0.666992 14.8718 0.666992 10.4168 0.666992 10.4168C0.666992 10.4168 0.666992 5.96166 1.22411 3.82643C1.53078 2.6483 2.43442 1.72057 3.58184 1.40571C5.66139 0.833496 14.0003 0.833496 14.0003 0.833496C14.0003 0.833496 22.3393 0.833496 24.4187 1.40571ZM11.5004 6.66674V15.0001L18.167 10.8336L11.5004 6.66674Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.6835446bd9725c46f94b62feafd391e0.svg";
export { ForwardRef as ReactComponent };